export default "__VITE_ASSET__BUcqM4Zd__"